(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("jump_app", [], factory);
	else if(typeof exports === 'object')
		exports["jump_app"] = factory();
	else
		root["jump_app"] = factory();
})(window, function() {
return 